import React, { useState } from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import LoginModal from "../Components/Modals/LoginModal";

type Props = NativeStackScreenProps<RootStackParamList, "Login">;

type LoginIdentity = "username" | "phone";
type LoginAlert = { type: "error" | "success"; message: string };

const LoginScreen: React.FC<Props> = ({ navigation }) => {
  const [identity, setIdentity] = useState<LoginIdentity>("username");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    username: "",
    mobileNumber: "",
    password: "",
  });
  const [errors, setErrors] = useState<{
    username?: string;
    mobileNumber?: string;
    password?: string;
  }>({});

  const onChange = (name: keyof typeof data, value: string) =>
    setData((d) => ({ ...d, [name]: value }));

  const onSave = () => {
    // validate / submit here if you want
    setLoading(true);
    // example/end: setLoading(false)
  };

  const setAlert = (_a: LoginAlert) => {};
  const onSuccess = (_token: string) => {};

  return (
    <LoginModal
      //   visible
      onClose={() => navigation.goBack()}
      data={data}
      errors={errors}
      onSave={onSave}
      onChange={onChange}
      identity={identity}
      loading={loading}
      setIdentity={setIdentity}
      setAlert={setAlert}
      onSuccess={onSuccess}
      // modifyModal optional
    />
  );
};

export default LoginScreen;
